<template>
  <v-card max-width="426" class="mx-auto pa-6 text-center">
    <h2 class="text-capitalize text-h5 text--secondary my-5 text-center">
      {{ $t("auth.emailVerification.title") }}
    </h2>
    <v-form
      @submit.prevent="onSubmit"
      ref="emailVerification"
      class="email-verification"
    >
      <v-text-field
        :placeholder="$t('auth.emailVerification.form.code')"
        :rules="codeRules"
        filled
        autofocus
        v-model="code"
        class="theme-custom-input ma-auto"
      />
      <transition mode="out-in" name="route">
        <p
          class="text-center font-regular-11 darker--text mb-7"
          v-if="!isCounterExpired"
        >
          {{ $t("auth.emailVerification.form.resendCodeTimer") }}
          {{ countdownTimer }}
        </p>

        <v-row align="center" justify="center" class="mx-0 mb-7" v-else>
          <v-btn
            class="font-medium-14"
            text
            color="primary"
            :loading="repeatLoading"
            @click="resendCode"
          >
            {{ $t("auth.emailVerification.form.resendCode") }}
          </v-btn>
        </v-row>
      </transition>

      <v-card-actions class="pa-0 auth-btn">
        <v-btn
          color="primary"
          :loading="loading"
          block
          class="py-7"
          type="submit"
        >
          {{ $t("auth.emailVerification.form.nextButton") }}
        </v-btn>
      </v-card-actions>

      <v-row justify="start" class="mt-4">
        <v-btn
          text
          color="primary"
          class="text-capitalize"
          :to="{ name: 'forgetPassword' }"
        >
          <v-icon
            size="20"
            :color="$vuetify.theme.themes.light.primary"
            :class="['me-2', { 'icon-rotation': $vuetify.rtl }]"
          >
            mdi-arrow-left-thin
          </v-icon>

          <span class="font-medium-14">
            {{ $t("auth.emailVerification.backButton") }}
          </span>
        </v-btn>
      </v-row>
    </v-form>
  </v-card>
</template>
<script>
import { authService } from "@/services";
// import { mapGetters, mapActions } from "vuex";
import countdown from "@/mixins/countdown";

export default {
  name: "email-verification",
  components: {},
  mixins: [countdown],
  props: [],
  data() {
    return {
      loading: false,
      code: "",
      repeatLoading: false,
      codeRules: [
        val => !!val || this.$t("auth.emailVerification.form.codeNotEmpty")
      ],
      otpToken: null
    };
  },
  // computed: {
  //   ...mapGetters({
  //     otpTokenData: "Auth1/GET_OTP_TOKEN_DATA"
  //   })
  // },
  mounted() {
    if (localStorage.getItem("otpToken")) {
      this.otpToken = localStorage.getItem("otpToken");
      this.getOtpInfo();
    } else {
      this.$router.replace({ name: "forgetPassword" });
    }
  },
  methods: {
    // ...mapActions({
    //   forgetPasswordData: "Auth1/SET_OTP_TOKEN_DATA"
    // }),
    async getOtpInfo() {
      // localStorage.removeItem("otpToken");
      await authService.otpInfo(this.otpToken).then(response => {
        this.$countdown(response.data.data.ttl);
      });
      // localStorage.setItem("otpToken", this.otpToken);
    },
    async resendCode() {
      // localStorage.removeItem("otpToken");
      this.repeatLoading = true;
      await authService
        .resendOtp(this.otpToken)
        .then(response => {
          this.$countdown(response.data.data.ttl);
          this.setToken(response.data.data.otpToken);
          this.isCounterExpired = false;
        })
        .finally(() => {
          this.repeatLoading = false;
        });
      // localStorage.setItem("otpToken", this.otpToken);
    },
    onSubmit() {
      if (!this.$refs.emailVerification.validate()) {
        return;
      }
      // localStorage.removeItem("otpToken");
      this.loading = true;
      authService
        .forgetPasswordOtp(this.code, this.otpToken)
        .then(response => {
          this.setToken(response.data.forgotPasswordToken);
          this.$router.push({ name: "resetPassword" });
        })
        .catch(() => {
          // localStorage.setItem("otpToken", this.otpToken);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setToken(value) {
      this.otpToken = value;
      localStorage.setItem("otpToken", value);
    }
  }
};
</script>
<style lang="scss">
@import "EmailVerification";
</style>
